module.exports = __webpack_public_path__ + "static/media/2022_2A3A9679.e9f01ec0.jpg";